import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import LocationForm from './LocationForm'
import { RouteTypes } from '~/routes/constants'
import FormWrapper from '../../Farmers/CreateEditFarmers/FormWrapper'
import DairyQuery from '~/QueryHooks/DairyQuery'
import { handleErrors, parseDate } from '~/utils/helpers'
import DairyService from '~/api/services/dairy'
import notify from '~/components/Notify'
import { useNavigate } from 'react-router'
import ManagerInfo from './ManagerInfo'

export const SWISS_COUNTRY_ISO = 'ch'

const CreateManager: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [isBusy, setIsBusy] = useState(false)

  const methods = useForm({
    mode: 'onSubmit'
  })

  const {
    data: countries,
    isLoading: isLoadingCountries,
    refetch: fetchCountries
  } = DairyQuery.getCountriesList()

  const {
    data: managerOptions,
    isLoading: isLoadingOptions,
    refetch: refetchOptions
  } = DairyQuery.getManagersOptions()

  useEffect(() => {
    refetchOptions()
    fetchCountries()
    const swissCountry = countries?.find(country => country?.iso === SWISS_COUNTRY_ISO)
    if (swissCountry) {
      methods.setValue('mobilePrefix', swissCountry?.id)
      methods.setValue('countryId', swissCountry?.id)
    }
  }, [t, countries])

  function renderForm() {
    return <>
      <FormWrapper header={t('Manager basic info')}>
        <ManagerInfo
          managerOptions={managerOptions}
          countries={countries || []}
        />
      </FormWrapper>

      <FormWrapper header={t('Location information for the manager')}>
        <LocationForm useGoogleMapLocation countries={countries} />
      </FormWrapper>

    </>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if (data.membershipApplicationDate) {
        data.membershipApplicationDate = parseDate(data.membershipApplicationDate)
      }
      await DairyService.storeManager(data)
      notify(t('Successfully create manager'), 'success')
      navigate(RouteTypes.DAIRY_FACTORY_MANAGERS)
    } catch (errors) {
      handleErrors(errors)
    }
    setIsBusy(false)
  }

  return <Layout
    title={t('Create manager')}
    onSubmit={methods.handleSubmit(onSubmit)}
    segmented
    isBusy={isLoadingOptions || isBusy || isLoadingCountries}
    close={RouteTypes.DAIRY_FACTORY_MANAGERS}
    action={t('Add manager')}
  >
    <FormProvider {...methods}>
      {renderForm()}
    </FormProvider>
  </Layout>
}
export default CreateManager